/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconCircle, IconCircleCheckFilled, IconX } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import { useOrderLabelPrintMutation } from "../../../apis/orderApis";
import toast from "react-hot-toast";

type LabelPrintModalProps = {
  open: boolean;
  onClose: () => void;
  order: any;
};

export default function LabelPrintModal({
  open,
  onClose,
  order,
}: LabelPrintModalProps) {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm<any>();

  const [step, setStep] = useState<"generate" | "preview">("generate");
  const [selectedSystem, setSelectedSystem] = useState<"default" | "3pl">(
    "default",
  );
  const printRef = useRef<HTMLDivElement>(null);
  const { mutate, isPending } = useOrderLabelPrintMutation(order?.id ?? "");

  const handleGenerate = (data: any) => {
    const payload = {
      ...data,
      system: selectedSystem,
      size: "4 x 6 inches",
    };

    mutate(payload, {
      onSuccess: (data: any) => {
        onClose();
      },
      onError: (error) => {
        console.log(error, "error");
        toast.error(`${error}`);
      },
    });
    // onClose()
  };

  const handlePrint = () => {
    if (!printRef.current) return;
    const content = printRef.current.innerHTML;
    const win = window.open("", "", "width=800,height=600");
    if (win) {
      win.document.write(`
          <html>
            <head><title>Print</title></head>
            <body onload="window.print(); window.close();">
              ${content}
            </body>
          </html>
        `);
      win.document.close();
    }
  };

  if (!open) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
      <div className="rounded-2xl ">
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h2 className="text-2xl">Label Print</h2>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>
        <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className="w-[655px]">
            {step === "generate" && (
              <>
                {/* Content */}
                <div className="">
                  <p className="text-sm font-medium mb-2">Select System</p>
                  <div className="grid grid-cols-2 gap-4">
                    {/* Default Label Print */}
                    <div
                      onClick={() => setSelectedSystem("default")}
                      className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer ${
                        selectedSystem === "default"
                          ? "bg-[#FBD037]/10 border-[#FBD037]"
                          : "bg-transparent border-[#D8D8D8]"
                      }`}
                    >
                      <div>
                        {selectedSystem === "default" ? (
                          <IconCircleCheckFilled className="text-[#FBD037]" />
                        ) : (
                          <IconCircle className="text-black/60" />
                        )}
                      </div>
                      <div>
                        <p className="text-base font-medium">
                          Default Label Print
                        </p>
                        <p className="text-sm text-[#212121]/80">
                          Default System AWB
                        </p>
                      </div>
                    </div>

                    <Input
                      title="Size"
                      name="size"
                      value="4 x 6 inches"
                      className=""
                      register={register}
                      disabled
                    />

                    {/* <Input
                      title="No. of Pieces"
                      name="noOfPieces"
                      type="number"
                      placeholder=""
                      className=""
                      register={register}
                      error={errors?.noOfPieces}
                      validation={{
                        required: "No. of pieces is required",
                        min: {
                          value: 1,
                          message: "At least 1 piece is required",
                        },
                        max: {
                          value: 9999,
                          message: "Maximum allowed is 9999 pieces",
                        },
                      }}
                    /> */}
                  </div>
                </div>

                {/* Footer */}
              </>
            )}
          </div>
        </div>

        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          <button
            onClick={handleSubmit(handleGenerate)}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
          >
            {isPending ? "Generating..." : "Generate"}
          </button>
        </div>
      </div>
    </div>
  );
}
